import { SitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { PrimaryLayout } from '../../layouts/PrimaryLayout/PrimaryLayout';
import { Primary404Props } from './Primary404.types';

export const Primary404 = (props: Primary404Props): JSX.Element => {
  return (
    <SitecoreContext componentFactory={props.componentFactory} layoutData={props.layoutData}>
      <PrimaryLayout layoutData={props.layoutData} headLinks={props.headLinks} />
    </SitecoreContext>
  );
};

export default Primary404;
